import { render, staticRenderFns } from "./individu.vue?vue&type=template&id=a408f5c4&"
import script from "./individu.vue?vue&type=script&lang=js&"
export * from "./individu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports